import { Alert } from '@material-ui/lab';
import * as React from 'react';

function TaxAlert() {
  return (
    <Alert severity='warning'>
      A cobrança do IOF ou outros encargos referentes a operadora de cartão de crédito do cliente final são de responsabilidade única e exclusivas dos
      mesmos. Não há opção de parcelamento para compras internacionais. A conversão em real exibida na tabela acima é apenas um demonstrativo diário
      do valor cadastrado convertido em real, lembrando que em todas suas vendas o valor do produto será o valor correspondido no momento da compra.
    </Alert>
  );
}

export { TaxAlert };
